<template>
  <header :class="{ Scroll: scrollPosition > 80 }">
    <div class="row-black clearfix">
      <div class="content-960">
        <button
          type="button"
          id="sidebarCollapse"
          class="btn btn-dark rounded ml-2 float-left mr-3 mt-1"
          @click="toggle()"
        >
          <i class="fa fa-bars" aria-hidden="true"></i>
        </button>

        <a href="/admin" title="Logo CNA" class="logo-header">
          <img
            src="../assets/imagens/logos/logo-CNA-big.png"
            alt="Imagem Logo CNA"
            title="Ação Comercial"
            class="logo-desktop"
          />
        </a>

        <div class="user">
          <div class="click-menu click-animate">
            <!-- <div class="img-user">
              <img :src="urlFoto" alt="Imagem do Usuário" :title="user.name" />
            </div> -->
            <h2>
              Olá,
              <span :title="user.name">{{ user.name }}</span>
            </h2>

            <div class="cna-local">
              <span :title="escolaNome">{{ escolaNome }}</span>
            </div>
          </div>
          <div class="wrap-conteudo">
            <div class="dados-user-mobile">
              <h2>
                Olá,
                <span>{{ user.name }}</span>
              </h2>
              <div class="cna-local">{{ escolaNome }}</div>
            </div>
          </div>
          <b-dropdown
            id="dropdown-1"
            text
            toggle-class="text-decoration-none text-white"
            class="menu-user"
            variant="link"
            right
          >
            <b-dropdown-item>
              <a
                class="icons-arrows"
                href="javascript:void(0);"
                @click="irParaPortalCorporativo()"
              >
                <span>Ir para Portal Corporativo</span>
              </a>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link to="/trocarescola" class="icons-arrows">
                <span>Trocar escola</span>
              </router-link>
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item class="text-right bg-dark">
              <a style="cursor: pointer" @click="logout()" class="text-light">
                <i class="fa fa-sign-out"></i> Sair
              </a>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- Sidebar  -->
    <nav id="sidebar" v-bind:class="{ active: isActive }">
      <div id="dismiss" @click="toggle()">
        <i class="fa fa-close"></i>
      </div>
      <div class="user">
        <div class="media">
          <!-- <div class="img-user-sidebar mr-2">
            <img :src="urlFoto" alt="Imagem do Usuário" :title="user.name" />
          </div> -->

          <div class="media-body">
            <div class="click-menu click-animate">
              <h2>
                Olá,
                <span :title="user.name">{{ user.name }}</span>
              </h2>
              <div class="cna-local">
                <span :title="escolaNome">{{ escolaNome }}</span>
              </div>
            </div>
          </div>
          <!-- b-[Optional: add media children here for nesting] -->
        </div>
      </div>

      <ul class="list-unstyled components" @click="toggle()">
        <!--MENU DESKTOP-->

        <li v-canaccess="'/admin'">
          <router-link to="/admin">Home</router-link>
        </li>
        <!-- <li v-canaccess="'/publicacao'">
          <router-link to="/publicacao">Publicações</router-link>
        </li>
        <li v-canaccess="'/chat'">
          <router-link to="/home">Chat</router-link>
        </li>
        <li v-canaccess="'/usuarios'">
          <router-link :to="'/usuarios'">Usuários</router-link>
        </li> -->
        <!-- <li v-canaccess="'/termouso'">
              <router-link :to="'/termouso'">Termo de Uso</router-link>
          </li> -->
      </ul>
    </nav>
    <div
      class="overlay"
      v-bind:class="{ active: isActive }"
      @click="toggle()"
    ></div>
  </header>
</template>
<script>
import Global from "@/common/global";
import Auth from "@/common/auth";

export default {
  name: "header-cna",
  data() {
    return {
      urlPortalCorporativo: Global.URL_PORTAL_CORPORATIVO,
      user: { escolas: [] },
      foto: "",
      scrollPosition: null,
      isActive: false,
    };
  },
  computed: {
    urlFoto() {
      return (
        Global.URL_DOWNLOAD +
        "colaborador-foto/" +
        this.foto +
        "?v=" +
        Math.random()
      );
    },
    escolaNome() {
      var escola = this.user.escolas.filter(
        (_) => _.escolaId == +this.user.tenant
      )[0];
      if (escola) return escola.nomeEscola;
      return "--";
    },
  },
  methods: {
    irParaPortalCorporativo: function () {
      sessionStorage.clear();
      window.location = this.urlPortalCorporativo;
    },
    logout: function () {
      Auth.logout();
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    toggle: function () {
      this.isActive = !this.isActive;
      let myBody = document.getElementsByTagName("body")[0];
      myBody.classList.toggle("modal-open");
    },
    checkIsLogged: function() {
        if(!this.user)
          this.logout()
    }
  },
  mounted() {
    this.user = Auth.currentUser();
    this.checkIsLogged();
    this.foto = Auth.getFotoUser();
    window.addEventListener("scroll", this.updateScroll);
  },
};
</script>